/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3CanistersCanisterIdRequest = {
  /**
   * Canister ID
   */
  canisterId: string;
};

/** @internal */
export const GetApiV3CanistersCanisterIdRequest$inboundSchema: z.ZodType<
  GetApiV3CanistersCanisterIdRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  canister_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "canister_id": "canisterId",
  });
});

/** @internal */
export type GetApiV3CanistersCanisterIdRequest$Outbound = {
  canister_id: string;
};

/** @internal */
export const GetApiV3CanistersCanisterIdRequest$outboundSchema: z.ZodType<
  GetApiV3CanistersCanisterIdRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3CanistersCanisterIdRequest
> = z.object({
  canisterId: z.string(),
}).transform((v) => {
  return remap$(v, {
    canisterId: "canister_id",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3CanistersCanisterIdRequest$ {
  /** @deprecated use `GetApiV3CanistersCanisterIdRequest$inboundSchema` instead. */
  export const inboundSchema = GetApiV3CanistersCanisterIdRequest$inboundSchema;
  /** @deprecated use `GetApiV3CanistersCanisterIdRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3CanistersCanisterIdRequest$outboundSchema;
  /** @deprecated use `GetApiV3CanistersCanisterIdRequest$Outbound` instead. */
  export type Outbound = GetApiV3CanistersCanisterIdRequest$Outbound;
}

export function getApiV3CanistersCanisterIdRequestToJSON(
  getApiV3CanistersCanisterIdRequest: GetApiV3CanistersCanisterIdRequest,
): string {
  return JSON.stringify(
    GetApiV3CanistersCanisterIdRequest$outboundSchema.parse(
      getApiV3CanistersCanisterIdRequest,
    ),
  );
}

export function getApiV3CanistersCanisterIdRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3CanistersCanisterIdRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3CanistersCanisterIdRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3CanistersCanisterIdRequest' from JSON`,
  );
}
